import axios from 'axios'
import { getToken } from '@/utils/auth'
import store from '@/stores'
import { getApiBaseUrl } from '@/utils/runtime-config'
const DEFAULT_API_URI = 'https://contest.api.smart3care.com'
const DEFAULT_TIMEOUT = 30000 * 3

// create an axios instance
const service = axios.create({
  // runtime override (on-prem) → build-time env → hard-coded default
  baseURL: getApiBaseUrl(process.env.VUE_APP_API_URI || DEFAULT_API_URI),
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: DEFAULT_TIMEOUT
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters['user/token']) {
      config.headers['x-access-token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    // 沒有公司的錯誤規範，直接返回 response
    if (response.status === 200) {
      return {
        token: response.headers['x-access-token'],
        data: response.data
      }
    } else {
      return response
    }
  },
  error => {
    // 檢查 error.response 是否存在
    if (error.response) {
      // 伺服器有回應但狀態碼不是 2xx
      if (error.response.status === 401) {
        console.log('401 error', error.response.data)
        return Promise.reject(error.response.data)
      }
      return Promise.reject(error.response.data)
    } else if (error.request) {
      // 請求已發送但沒有收到回應
      console.error('No response received:', error.request)
      return Promise.reject({
        code: -1,
        message: '網絡錯誤，請檢查連線',
        error: error.message
      })
    } else {
      // 請求配置出錯
      console.error('Request setup error:', error.message)
      return Promise.reject({
        code: -1,
        message: '請求錯誤',
        error: error.message
      })
    }
  }
)

export default service
